import React from "react";
import paymentFailed from "../../images/paymentFailed.svg";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";


const PaymentFailed = () => {

    return (
        // <div className="p-6 bg-gray-100 min-h-screen">
        //     <h1 className="text-2xl font-bold mb-6">Payment Failed</h1>
        // </div>
        <div>
        <div className="app-container-viewLeadDetails">
          <MiniDrawer />
          <div
            style={{ overflowX: "hidden" }}
            className="container-fluid container-viewLeadDetails"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
              className="country-header"
            ></div>
  
            <div>
              <div className="container-fluid px-3 py-2" style={{ width: "59%" }}>
                <div
                  className="mt-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img src={paymentFailed} alt="paymentFailed" style={{marginTop: "18px",width: "39%"}}/>
                  <h1 style={{fontWeight: "600",padding: "15px"}}>Payment Failed!</h1>
                  <p style={{fontSize: "13px",fontStyle: "italic",fontWeight: "500"}}>
                  Hey, seems like there was some trouble.<br/> Please try again or return to home page
                  </p>
                  
                  <p style={{fontSize: "10px"}}>Payment ID : 010101 Date & Time : 24 Jan 2025 | 09:43AM</p>
                  <div>

                  <button style={{backgroundColor:"#5B489D",color:"#FFFFFF",height: "37px",border: "none"}}>Home</button>
                  <button style={{height: "37px",marginLeft: "9px", backgroundColor:"#ECECEC",border: "none"}}>Try again</button>
                  </div>
                </div>
  
                <div className="expenseList"></div>
              </div>
            </div>
            {/* ------------------------customer deatil--------------------- */}
          </div>
        </div>
      </div>
    )
}

export default PaymentFailed